var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FlatpageLegalBase", [
    _c("h1", [_vm._v("Brilliant Community FAQ")]),
    _vm._v(" "),
    _c("h3", [_vm._v("What's happening, and when?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    We are sunsetting our community features, in order to focus on expanding features and content\n    coverage for our library of interactive courses.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    On "),
      _c("strong", [_vm._v("July 2, 2021")]),
      _vm._v(
        ", the community section was removed from Brilliant. We also\n    stopped accepting new explanation submissions on Daily Challenges.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Why are community features going away?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    As a small team, we must focus on the efforts that make the largest impact toward achieving\n    our mission of inspiring and developing people to achieve their goals in STEM. It is\n    "
      ),
      _c("a", { attrs: { href: "#clear-section" } }, [_vm._v("clear")]),
      _vm._v(
        "\n    that focusing on our interactive courses is the right path forward, and we'll continue to\n    expand and enhance our interactive course offerings for years to come.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Will I be able to download my content?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    Yes, you can\n    "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://brilliant.org/account/settings/data-portal/user-content-download/"
          }
        },
        [_vm._v("download")]
      ),
      _vm._v(
        "\n    all problems and solutions that you've published. This link will be available until December\n    31, 2021. We have also created a publicly available archive of community content available for\n    download\n    "
      ),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://ds055uzetaobb.cloudfront.net/exported_user_content.zip"
          }
        },
        [_vm._v("here")]
      ),
      _vm._v("\n    (9.1gb compressed, 18.9gb uncompressed)\n  ")
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("How will this change affect Daily Challenges?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    We will continue to publish Daily Challenges every day. However, in the coming weeks, we will\n    be turning off the functionality for users to submit or discuss explanations to Daily\n    Challenges. Moving forward, Daily Challenges will have Brilliant staff-written solutions.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Will there be a community in the future?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Probably! We remain fervent believers in the power of community to provide motivation and\n    support in someone's STEM learning journey. We will likely launch community components\n    alongside our interactive courses in the coming years.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Are there other ways to write content on Brilliant?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    We are opening up our course authoring tools to vetted creators as part of expanding our\n    interactive course offerings. If you're interested in being a course author on Brilliant, you\n    can sign up for more information\n    "
      ),
      _c("a", { attrs: { href: "https://airtable.com/shr62joby7e4OQTve" } }, [
        _vm._v("here")
      ]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Have additional questions?")]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    Email us at\n    "),
      _c("a", { attrs: { href: "mailto:support@brilliant.org" } }, [
        _vm._v("support@brilliant.org")
      ]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Community Discord")]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    Some community members have formed a\n    "),
      _c("a", { attrs: { href: "https://discord.gg/nhaWmhfv2N" } }, [
        _vm._v("Discord")
      ]),
      _vm._v(
        "\n    to keep in touch. While this Discord is not directly affiliated with or endorsed by Brilliant,\n    we wanted to share that link to give folks a way to keep in touch.\n  "
      )
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "light-hr" }),
    _vm._v(" "),
    _c("div", { staticClass: "anchor", attrs: { id: "clear-section" } }),
    _vm._v(" "),
    _c("h2", [_vm._v("Brilliant's path forward")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Since 2014, over 100,000 problems have been published by over 10,000 people from 130 different\n    countries. Throughout its history, the Brilliant community has been one of the largest and\n    most active communities of people sharing, solving, and discussing problems and puzzles across\n    math and science.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    However, our guided, interactive courses are overwhelmingly the way that STEM learners want to\n    use Brilliant to achieve their goals in STEM. Since their launch in 2017, usage of our courses\n    has rapidly accelerated, and is now >15x the usage of community features. Over that time,\n    the number of community contributors has decreased >80%.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    While it might be hard to see on the surface, maintaining our community features is quite\n    complex - with the ongoing work and maintenance ranging from authoring tools, to moderation,\n    to content discoverability.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    We've also received consistent feedback for several years that the community experience is\n    confusing or intimidating for most users, who have joined Brilliant in order to advance their\n    goals in STEM by learning a particular topic in a guided way.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    This does not diminish the impact our community has had on learners around the world - and, in\n    turn, the likely disappointment discontinuing community features will bring many of you.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    Many of us on the Brilliant team were ourselves early and avid members of the community, and\n    continued to participate during our time working at Brilliant. We've felt the immense joy of\n    sharing puzzles with problem-solvers around the world, the satisfaction of solving a hard\n    puzzle late at night and sharing a solution for others to learn from, and the occasional\n    frustration from trolls and erroneous reports.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    As a small team, we must focus on the efforts that make the largest impact toward achieving\n    our mission of inspiring and developing people to achieve their goals in STEM. It is clear\n    that focusing on our interactive courses is the right path forward, and we'll continue to\n    expand and enhance our interactive course offerings for years to come.\n  "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }